import t from 'lib/i18n';

const PassengerRow = ({ adults, children, railcardName = '' }) => {
  let srText = '';
  srText += adults ? `${adults} ${adults > 1 ? t('adults') : t('adult')}` : '';
  srText += children ? `${children} ${children > 1 ? t('children') : t('child')}` : '';
  srText += railcardName ? ` with ${railcardName}` : '';
  srText += '.';

  return (
    <div className="otrl-jp__favourite-ticket__passengers__row" aria-label={srText}>
      <div className="otrl-jp__favourite-ticket__passengers__row__left">
        {adults && `${adults} x ${t('adult')}`}
        {children && `${children} x ${t('child')}`}
      </div>
      <div className="otrl-jp__favourite-ticket__passengers__row__right">
        {railcardName}
      </div>
    </div>
  )
};

export default PassengerRow;